export const API_URL = process.env.REACT_APP_API_URL || 'https://spectraine-backend.onrender.com';
export const APP_NAME = 'Spectraine';
export const SUBSCRIPTION_PRICE = '$497/month';
export const RISK_LEVELS = {
  Critical: { color: '#EF4444', bgColor: '#FEE2E2' },
  High: { color: '#F59E0B', bgColor: '#FEF3C7' }
};